/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

import PropTypes from 'prop-types';
import { Component, isValidElement } from 'react';
import RequestStatus from '../models/RequestStatus';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const isFailed = statuses => statuses.some(status => status.failed);
const isLoading = statuses => statuses.some(status => status.uninitialized || status.pending);
export default class LoadingHOC extends Component {
  constructor(...args) {
    super(...args);
    this.renderError = () => {
      const {
        error
      } = this.props;
      if (error instanceof Object && error.hasOwnProperty('title')) {
        if (typeof error.title === 'string' && (!error.body || typeof error.body === 'string')) {
          return /*#__PURE__*/_jsx(UIAlert, {
            type: "danger",
            titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: error.title
            }),
            children: error.body && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: error.body
            })
          });
        }
        return /*#__PURE__*/_jsx(UIAlert, {
          type: "danger",
          titleText: error.title,
          children: error.body
        });
      } else if ( /*#__PURE__*/isValidElement(error)) {
        return error;
      }
      return null;
    };
  }
  render() {
    const {
      disableLoadingState,
      statuses,
      children,
      loadingElement
    } = this.props;
    if (disableLoadingState) return children;
    if (isFailed(statuses)) {
      return this.renderError();
    }
    if (isLoading(statuses)) {
      if ( /*#__PURE__*/isValidElement(loadingElement)) {
        return loadingElement;
      }
      return /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        minHeight: 200
      });
    }
    return children;
  }
}
LoadingHOC.propTypes = {
  children: PropTypes.node,
  disableLoadingState: PropTypes.bool,
  statuses: PropTypes.arrayOf(PropTypes.instanceOf(RequestStatus)).isRequired,
  loadingElement: PropTypes.node,
  error: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({
    title: PropTypes.node.isRequired,
    body: PropTypes.node
  })]).isRequired
};